import React from 'react'
import { Title } from '@/ui/components/Title'
import RichText from '@/ui/components/RichText'
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

interface HeaderProps {
  label?: string | null
  title?: string | null
  description?: string | SerializedEditorState | null
}

export const Header: React.FC<HeaderProps> = ({ label, title, description }) => {
  return (
    <div className="mb-10">
      {label && (
        <Title
          className="!text-label-XS-regular !font-normal text-text-faded mb-2 uppercase"
          hierarchy="h3"
        >
          {label}
        </Title>
      )}
      {title && (
        <Title className="!text-headline-L-semibold text-text-base mb-8" hierarchy="h2">
          {title}
        </Title>
      )}
      {description && (
        <>
          {typeof description === 'string' ? (
            <p className="text-body-M-regular text-text-subtle xl:w-2/3">{description}</p>
          ) : (
            <RichText
              data={description}
              className="text-body-M-regular text-text-subtle prose-p:!text-body-M-regular prose-p:!text-text-subtle prose-p:!mb-0"
              enableGutter={false}
              enableProse={false}
            />
          )}
        </>
      )}
    </div>
  )
}
